import { CASE_DELETE_BLOCKED_STATUSES } from '@/constants';

/** Lower-cases and un-snake-cases so the display label ("AI Pagination
 *  Processing") and the raw key ("AI_PAGINATION_PROCESSING") compare equal. */
const normalise = (status?: string | null) => (status || '').toLowerCase().replace(/_/g, ' ');

/**
 * True while the case is mid AI processing, when its documents must not be
 * deleted. Accepts either shape of status because the case-status endpoint and
 * the medical-records list return them differently.
 */
export const isDocumentDeleteBlockedByCaseStatus = (caseStatus?: string | null) => {
  const status = normalise(caseStatus);
  return status.length > 0 && CASE_DELETE_BLOCKED_STATUSES.some((blocked) => normalise(blocked) === status);
};
